import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/oswald/400.css";
import "@fontsource/oswald/500.css";
import "@fontsource/oswald/700.css";
import "@fontsource/source-sans-3/400.css";
import "@fontsource/source-sans-3/600.css";
import App from "./App";
import ConsoleShell from "./ConsoleShell";
import ConsoleSessionBoundary from "./ConsoleSessionBoundary";
import GuestApp from "./GuestApp";
import "./styles.css";
import "./console.css";
import "./console-list.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* Issue #1053: the authorised-guest area never renders the staff console. */}
    {window.location.pathname === "/guest" || window.location.pathname.startsWith("/guest/") ? <GuestApp /> : window.location.pathname.startsWith("/console") ? <ConsoleSessionBoundary><ConsoleShell /></ConsoleSessionBoundary> : <App />}
  </React.StrictMode>
);
